import React from 'react';

const GarageLogo = ({ size = 32 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 64 64" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Garage structure */}
      <path 
        d="M32 8L8 24V56H56V24L32 8Z" 
        fill="url(#gradient1)"
        stroke="#5568d3"
        strokeWidth="2"
      />
      
      {/* Garage door */}
      <rect 
        x="18" 
        y="34" 
        width="28" 
        height="22" 
        rx="2"
        fill="#ffffff"
        stroke="#5568d3"
        strokeWidth="2"
      />
      
      {/* Door lines */}
      <line x1="18" y1="40" x2="46" y2="40" stroke="#667eea" strokeWidth="1.5"/>
      <line x1="18" y1="46" x2="46" y2="46" stroke="#667eea" strokeWidth="1.5"/>
      <line x1="18" y1="52" x2="46" y2="52" stroke="#667eea" strokeWidth="1.5"/>
      
      {/* Door handle */}
      <circle cx="40" cy="48" r="2" fill="#667eea"/>
      
      {/* Roof accent */}
      <path 
        d="M32 8L8 24H56L32 8Z" 
        fill="url(#gradient2)"
        opacity="0.6"
      />
      
      {/* Gradient definitions */}
      <defs>
        <linearGradient id="gradient1" x1="8" y1="8" x2="56" y2="56" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#667eea"/>
          <stop offset="100%" stopColor="#764ba2"/>
        </linearGradient>
        <linearGradient id="gradient2" x1="8" y1="16" x2="56" y2="16" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.3"/>
          <stop offset="50%" stopColor="#ffffff" stopOpacity="0.1"/>
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0.3"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GarageLogo;
